import { render, staticRenderFns } from "./Pump6ColumnTable.vue?vue&type=template&id=38a23d0a&scoped=true"
import script from "./Pump6ColumnTable.vue?vue&type=script&lang=js"
export * from "./Pump6ColumnTable.vue?vue&type=script&lang=js"
import style0 from "./Pump6ColumnTable.vue?vue&type=style&index=0&id=38a23d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a23d0a",
  null
  
)

export default component.exports